import { render, staticRenderFns } from "./AccountCollection.vue?vue&type=template&id=c67ba73e&scoped=true&"
import script from "./AccountCollection.vue?vue&type=script&lang=js&"
export * from "./AccountCollection.vue?vue&type=script&lang=js&"
import style0 from "./AccountCollection.vue?vue&type=style&index=0&id=c67ba73e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_prettier@3.0.3_vue-template-compiler@2.6.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67ba73e",
  null
  
)

export default component.exports